export const phoneNumberRegex: (min?: number, max?: number) => RegExp = (min = 8, max = 20) => RegExp(`^[\\d ]{${min},${max}}$`);
export const emailRegex: RegExp = RegExp(
  "^" +
    "(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*" +
    "@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)" +
    "$"
);
export const datocmsUUIDRegex: RegExp = RegExp("^[a-zA-Z0-9-_]+$");
export const urlRegex: RegExp = RegExp(
  "^https?:\\/\\/" +
    "(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\\.)+[a-zA-Z]{2,}" +
    "(?::\\d+)?" +
    "(?:\\/[^\\s]*)?" +
    "$"
);
